// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
    position: absolute;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7); 
    color: rgba(0, 0, 0, 0.7);
    z-index: 2;
}

.loader-text {
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
    font-size: 1rem;  
}

.clock-loader {
    --clock-color: rgba(189,48,44,1);
    --clock-width: 4rem;
    --clock-radius: calc(var(--clock-width) / 2);
    --clock-minute-length: calc(var(--clock-width) * 0.4);
    --clock-hour-length: calc(var(--clock-width) * 0.2);
    --clock-thickness: 0.2rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--clock-width);
    height: var(--clock-width);
    border: 3px solid var(--clock-color);
    border-radius: 50%;
  }
  .clock-loader::before, .clock-loader::after {
    position: absolute;
    content: "";
    top: calc(var(--clock-radius) * 0.25);
    width: var(--clock-thickness);
    background: var(--clock-color);
    border-radius: 10px;
    transform-origin: center calc(100% - calc(var(--clock-thickness) / 2));
    animation: spin infinite linear;
  }
  .clock-loader::before {
    height: var(--clock-minute-length);
    animation-duration: 2s;
  }
  .clock-loader::after {
    top: calc(var(--clock-radius) * 0.25 + var(--clock-hour-length));
    height: var(--clock-hour-length);
    animation-duration: 15s;
  }
  
  @keyframes spin {
    to {
      transform: rotate(1turn);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/loader/loader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,4CAA4C;IAC5C,qDAAqD;IACrD,mDAAmD;IACnD,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;IACnB,sEAAsE;IACtE,+BAA+B;EACjC;EACA;IACE,kCAAkC;IAClC,sBAAsB;EACxB;EACA;IACE,gEAAgE;IAChE,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE;MACE,wBAAwB;IAC1B;EACF","sourcesContent":[".loader-container {\r\n    position: absolute;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgba(0, 0, 0, 0.7); \r\n    color: rgba(0, 0, 0, 0.7);\r\n    z-index: 2;\r\n}\r\n\r\n.loader-text {\r\n    color: rgba(255, 255, 255, 0.5);\r\n    font-weight: 400;\r\n    font-size: 1rem;  \r\n}\r\n\r\n.clock-loader {\r\n    --clock-color: rgba(189,48,44,1);\r\n    --clock-width: 4rem;\r\n    --clock-radius: calc(var(--clock-width) / 2);\r\n    --clock-minute-length: calc(var(--clock-width) * 0.4);\r\n    --clock-hour-length: calc(var(--clock-width) * 0.2);\r\n    --clock-thickness: 0.2rem;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: var(--clock-width);\r\n    height: var(--clock-width);\r\n    border: 3px solid var(--clock-color);\r\n    border-radius: 50%;\r\n  }\r\n  .clock-loader::before, .clock-loader::after {\r\n    position: absolute;\r\n    content: \"\";\r\n    top: calc(var(--clock-radius) * 0.25);\r\n    width: var(--clock-thickness);\r\n    background: var(--clock-color);\r\n    border-radius: 10px;\r\n    transform-origin: center calc(100% - calc(var(--clock-thickness) / 2));\r\n    animation: spin infinite linear;\r\n  }\r\n  .clock-loader::before {\r\n    height: var(--clock-minute-length);\r\n    animation-duration: 2s;\r\n  }\r\n  .clock-loader::after {\r\n    top: calc(var(--clock-radius) * 0.25 + var(--clock-hour-length));\r\n    height: var(--clock-hour-length);\r\n    animation-duration: 15s;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    to {\r\n      transform: rotate(1turn);\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
